module.exports = __webpack_public_path__ + "static/media/tricycle.ca8aca1d.svg";